var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7eab8f843f1e34324ca31ba6695d79f2db72aa80"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mubazar-frontend@mubazar"]={id:"7eab8f843f1e34324ca31ba6695d79f2db72aa80"};
      